import { priceStatus } from './hide_prices.js'
import { handleEvent } from '../utils/events.js'

export let loading_popup = false

function handle_price(num) {
    return parseFloat(num).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
}

export async function handle_popup(id) {
    const popup = document.querySelector('#cart-popup')
    const content = document.querySelector('#cart-popup-content')
    let tempCart = {}

    loading_popup = true
    try {
        const response = await fetch(`/api/publication?id=${id}`, {
            method: 'GET',
        })
        const data = await response.json()
        const hasPrices = !!data.products[0]
        const prices = hasPrices
            ? [
                handle_price(data.products[0].priceDiscount),
                handle_price(data.products[0].priceList),
                handle_price(data.products[0].pricePublicDiscount * 1.21),
                handle_price(data.products[0].pricePublic * 1.21),
            ]
            : [0, 0, 0, 0]

        let current = 0
        const images = data.images.map((img) => img.link)
        function getContent() {
            const _content = `
         <div class="closed__pop" id="close__popup"><i class="fa-solid fa-xmark"></i></div>
         <div class="popup_content">
            <div class="data-left">
               <div class="images">
               ${images
                    .map(
                        (img, i) => `
                     <img class="image ${i === current ? 'current' : ''
                            }" src="${img}" onerror="this.src='/img/noImage.jpg'"/>
                     `
                    )
                    .join('')}
               <div class="indicator">
                  ${images.map((_, i) => `<span class="dot ${i === current ? 'active' : ''}"></span>`).join('')}
               </div>
               </div>
            </div>

            <div class="data-right">
                  <p class="popup__title">${data.title}</p>
                  <p class="sku">SKU: ${data.code}</p>
                  <div>
                        ${isUserLoggedIn
                    ? `
                              <div class="pop__prices" data-name="list__prices">
                                 <p> P. lista (sin IVA) </p>
                                 ${prices[1] !== prices[0] ? `<p class="line">$ ${prices[1]} </p>` : ''}
                                 <p>$ ${prices[0]} </p>
                              </div>
                              <div class="pop__prices">
                                 <p> PVP (IVA incluido) </p>
                                 ${prices[3] !== prices[2] ? `<p class="line">$ ${prices[3]} </p>` : ''}
                                 <p>$ ${prices[2]} </p>
                              </div>
                           `
                    : ''
                }
                  </div>

                  ${isUserLoggedIn
                    ? `
                        <p class="talles__select">Selecciona el Talle</p>
                        <div class="add_talles">
                              <div class="talles">
                                 <div class="opciones">
                                    <div id="sizes-container" class="sizes"></div>
                                 </div>
                              </div>

                              <div class="add_btn">
                                 <button id="enviar" class="subcarrito">Añadir al carrito</button>
                              </div>
                        </div>
                     `
                    : ''
                }
            </div>
          </div>
        `
            //   Se muestra el popup
            content.innerHTML = _content

            const btn_submit = popup.querySelector('#enviar')
            const talles = popup.querySelector('#sizes-container')
            const close = popup.querySelector('#close__popup')

            if (close) {
                close.addEventListener('click', () => {
                    popup.style.display = 'none'
                })
            }

            if (talles) {
                for (const product of data.products) {
                    if (Number(product.stock) <= -2) continue;
                    const talle_container = document.createElement('div')
                    const btn_talle = document.createElement('button')
                    const btn_minus = document.createElement('button')
                    const btn_plus = document.createElement('button')
                    const input = document.createElement('input')

                    // Añado clases a los botones, input y div
                    talle_container.className = 'talle__container'
                    btn_talle.className = 'size__btn'
                    btn_minus.className = 'minus'
                    btn_plus.className = 'plus'
                    input.className = 'campo'

                    input.placeholder = '0'
                    input.style.outline = 'none'
                    input.disabled = product.stock <= 0

                    btn_talle.innerText = product.size
                    btn_minus.innerHTML = `<i class="fa fa-minus"></i>`
                    btn_plus.innerHTML = `<i class="fa fa-plus"></i>`

                    const message = document.createElement('span');
                    message.className = 'stock-message';
                    message.style.color = 'red';
                    message.style.fontSize = '12px';
                    message.style.marginLeft = '5px';
                    message.style.display = 'none';
                    talle_container.appendChild(message);

                    input.addEventListener('keyup', (e) => {
                        let value = parseInt(e.target.value, 10) || 0;

                        if (value > product.stock) {
                            input.value = product.stock;
                            message.style.display = 'inline';
                            message.innerText = '¡No hay stock disponible!';
                        } else {
                            message.style.display = 'none';
                        }

                        tempCart[product.size] = {
                            input,
                            stock: product.stock,
                            cantidad: parseInt(input.value, 10) || 0,
                            size: product.size,
                            code: product.code,
                            id: product.id,
                        };
                    });

                    input.addEventListener('blur', (e) => {
                        let value = parseInt(e.target.value, 10) || 0;
                        if (value < 1) value = 0;

                        if (value > product.stock) {
                            value = product.stock;
                            message.style.display = 'inline';
                            message.innerText = '¡No hay stock disponible!';
                        } else {
                            message.style.display = 'none';
                        }

                        e.target.value = value;

                        tempCart[product.size] = {
                            input,
                            stock: product.stock,
                            cantidad: value,
                            size: product.size,
                            code: product.code,
                            id: product.id,
                        };
                    });

                    btn_minus.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (input.disabled === true) return;
                        let currentValue = parseInt(input.value, 10) || 1;
                        if (currentValue > 1) {
                            input.value = currentValue - 1;
                            message.style.display = 'none';
                        }
                        tempCart[product.size] = {
                            input,
                            stock: product.stock,
                            cantidad: parseInt(input.value, 10) || 0,
                            size: product.size,
                            code: product.code,
                            id: product.id,
                        };
                    });

                    btn_plus.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (input.disabled === true) return;
                        let currentValue = parseInt(input.value, 10) || 0;
                        if (currentValue < product.stock) {
                            input.value = currentValue + 1;
                            message.style.display = 'none';
                        } else {
                            message.style.display = 'inline';
                            message.innerText = '¡No hay stock disponible!';
                        }

                        tempCart[product.size] = {
                            input,
                            stock: product.stock,
                            cantidad: parseInt(input.value, 10) || 0,
                            size: product.size,
                            code: product.code,
                            id: product.id,
                        };
                    });

                    talle_container.appendChild(btn_talle)
                    talle_container.appendChild(btn_minus)
                    talle_container.appendChild(input)
                    talle_container.appendChild(btn_plus)
                    talles.appendChild(talle_container)
                    talle_container.appendChild(message)
                }

                btn_submit.addEventListener('click', () => {
                    if (!window.addItemToCart) return null
                    clearExistingItems(tempCart)
                    Object.entries(tempCart).forEach(([size, product]) => {
                        window.cart[size] = { ...product }
                    })

                    const e = {
                        name: 'addedToCartObjectIDs',
                        url: '/products',
                        payload: {
                            items: Object.values(tempCart).map((item) => ({
                                code: item.code,
                                cantidad: Number(item.cantidad),
                                stock: Number(item.stock),
                                id: item.id
                            })),
                            product_id: id,
                            code: data.code
                        },
                    }
                    handleEvent(e, undefined, { require_location: true })
                    window.addItemToCart()
                })

                function clearExistingItems(tempCart) {
                    Object.values(tempCart).forEach((product) => {
                        Object.entries(window.cart).forEach(([size, cartProduct]) => {
                            if (cartProduct.id === product.id) {
                                delete window.cart[size]
                            }
                        })
                    })
                }
            }

            const dots = content.querySelectorAll('.dot')

            dots.forEach((dot, i) => {
                dot.addEventListener('click', (e) => {
                    if (dot.classList.contains('active')) return null
                    current = i
                    getContent()
                })
            })
        }

        //inicio actualizacion
        getContent()

        // se cambia el display de popup
        popup.style.display = 'grid'

        priceStatus()
        loading_popup = false
    } catch (e) {
        console.error(e)
        loading_popup = false
    }
}
